import React from 'react';
import { ErrorMessageTemplate } from './error-handler-template';
import { MessengerLauncherWrapper } from 'works/legacy/components/messenger-launcher-wrapper';

export const StandardNoAccessErrorMessage = () => (
  <ErrorMessageTemplate
    title="Whoa whoa, hold on..."
    imageName="error-no-access"
    imageAlt="Padlock image meaning access denied"
  >
    <>
      Looks like you don&apos;t have access to this page or resource.
      <br />
      <MessengerLauncherWrapper>Chat with support</MessengerLauncherWrapper> for
      further assistance.
    </>
  </ErrorMessageTemplate>
);

export const ContextualNoAccessErrorMessage = () => (
  <p>Access denied. Please contact your administrator.</p>
);

export const NotificationNoAccessErrorMessage = () => (
  <p>
    <strong>
      Ops! Looks like you don&apos;t have access to this resource.
    </strong>{' '}
    Contact your administrator or{' '}
    <MessengerLauncherWrapper>chat with support</MessengerLauncherWrapper> for
    further assistance.
  </p>
);
